import React from "react"
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  Chip,
  useTheme,
} from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { format } from "date-fns"
import { ru } from "date-fns/locale"
import { ChatViewer } from "../interfaces/chatViewer"

interface PurchaseInfoAccordionProps {
  purchaseInfo: ChatViewer.PurchaseInfo
}

export const PurchaseInfoAccordion: React.FC<PurchaseInfoAccordionProps> = ({
  purchaseInfo,
}) => {
  const theme = useTheme()

  return (
    <Accordion
      disableGutters
      elevation={0}
      square
      sx={{
        "&:before": { display: "none" },
        mt: 2,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Typography variant="body2">Покупки</Typography>
          <Chip
            label={`${purchaseInfo.total_orders} заказов`}
            size="small"
            color="success"
          />
          <Chip
            label={`${purchaseInfo.total_sum_order} ₽`}
            size="small"
            variant="outlined"
          />
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ mb: 2 }}>
          <Typography variant="caption" color="text.secondary">
            Всего заказов: {purchaseInfo.total_orders} | Сумма заказов:{" "}
            {purchaseInfo.total_sum_order} ₽ | Оплачено:{" "}
            {purchaseInfo.total_sum_pay} ₽ | BTC: {purchaseInfo.total_sum_btc}
          </Typography>
        </Box>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>№ заказа</TableCell>
              <TableCell>Дата</TableCell>
              <TableCell>Статус</TableCell>
              <TableCell>Тип</TableCell>
              <TableCell>Откуда</TableCell>
              <TableCell align="right">Сумма</TableCell>
              <TableCell align="right">Оплачено</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {purchaseInfo.orders.map((order) => (
              <TableRow key={order.order_id}>
                <TableCell>{order.order_number}</TableCell>
                <TableCell>
                  {format(new Date(order.order_date), "dd.MM.yyyy", {
                    locale: ru,
                  })}
                </TableCell>
                <TableCell>
                  <Chip
                    label={order.status}
                    size="small"
                    color={order.status === "completed" ? "success" : "default"}
                  />
                </TableCell>
                <TableCell>{order.type}</TableCell>
                <TableCell>{order.from}</TableCell>
                <TableCell align="right">{order.sum_order} ₽</TableCell>
                <TableCell align="right">{order.sum_pay} ₽</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  )
}
